import Joi from "joi";

export const userSchema = Joi.object({
  firstname: Joi.string().min(2).label("Firstname"),
  lastname: Joi.string().min(2).label("Lastname"),
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .required()
    .label("Email"),
  password: Joi.string().min(2).label("Password"),
  isActive: Joi.boolean().label("Active"),
});
